// config.js
const environments = {
    1: "http://localhost:8080",
    2: "https://devbackend-225652761371.us-central1.run.app",
    3: "https://prodbackend-225652761371.us-central1.run.app",
    4: "https://my-backend.loca.lt",
  };
  // Select the desired environment here
  // 1 - Localhost
  // 2 - Development (Production-like)
  // 3 - Production
  // 4 - Localtunnel on same wifi

  const selectedEnv =2;
  
  const config = {
    API_BASE_URL: environments[selectedEnv],
  };
  
  export default config;